// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Text } from '@gandi/ui';

import {
  useDurationText,
  useExtendedSuggestion,
  usePriceText,
} from 'src/DomainCreate/components/ProvidedArea/modules/index';

type Props = { fqdn: string };

export function RenewPrice({ fqdn }: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const { currency, renewPrice, renewMinDuration, priceDiff } =
    useExtendedSuggestion({ fqdn });

  const renewPriceText = usePriceText({
    price: renewPrice,
    minDuration: renewMinDuration,
    needsPhaseSelection: false, // no phase selection for renewals
    currency,
  });

  const renewDuration = useDurationText({
    minDuration: renewMinDuration,
    timeLimited: false,
  });

  if (!priceDiff) return null;

  const isLowerRenewPrice = Number(priceDiff) > 0;

  // TODO: uniformize price duration logic and display with
  // src/DomainCreate/components/DomainList/AvailabilityCell/PriceText.js
  // and src/DomainCreate/components/ProvidedArea/PriceArea/CatalogPrice.js

  return !!renewPrice && !!renewMinDuration && Number(priceDiff) ? (
    <Text
      size="small"
      color={isLowerRenewPrice ? 'promotional' : 'light'}
      weight={isLowerRenewPrice ? 'semibold' : undefined}
      dangerouslySetInnerHTML={__('then %(renewPrice)s %(renewDuration)s', {
        renewPrice: renewPriceText,
        renewDuration,
        withHTML: true,
        escapeParameters: false,
      })}
    />
  ) : null;
}
